function sorguDizgesi(sorgu) {
    const params = new URLSearchParams();
    if (sorgu.sayfa)
        params.set('sayfa', String(sorgu.sayfa));
    if (sorgu.boyut)
        params.set('boyut', String(sorgu.boyut));
    if (sorgu.noktaId)
        params.set('noktaId', sorgu.noktaId);
    if (sorgu.dolapId)
        params.set('dolapId', sorgu.dolapId);
    if (sorgu.cihazUid)
        params.set('cihazUid', sorgu.cihazUid);
    if (sorgu.tip)
        params.set('tip', sorgu.tip);
    if (sorgu.baslangicTen)
        params.set('baslangicTen', sorgu.baslangicTen);
    if (sorgu.baslangicAKadar)
        params.set('baslangicAKadar', sorgu.baslangicAKadar);
    const s = params.toString();
    return s ? `?${s}` : '';
}
export async function cihazOlaylariListele(istemci, sorgu = {}) {
    return istemci.istek(`/cihaz-olaylari${sorguDizgesi(sorgu)}`);
}
//# sourceMappingURL=cihaz-olaylari.js.map